import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "row"
}
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "d-grid gap-2 d-md-flex justify-content-md-end mt-4" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 0,
  class: "spinner-border spinner-border-sm mb-1",
  role: "status",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    ref: "solverModal",
    title: "Solve shortfall",
    idKey: "solverModal",
    key: "solverModal",
    "close-button-aria-label": _ctx.modalCloseButtonAriaLabel
  }, {
    default: _withCtx(() => [
      (_ctx.isEvaluating)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "row" }, [
              _createElementVNode("div", { class: "col" }, [
                _createElementVNode("p", null, "Evaluating...")
              ])
            ], -1)),
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "row" }, [
              _createElementVNode("div", { class: "col text-center" }, [
                _createElementVNode("div", {
                  class: "spinner-border",
                  role: "status"
                }, [
                  _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                ])
              ])
            ], -1))
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.isViable)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.solutionText, (solutionLine, i) => {
                      return (_openBlock(), _createElementBlock("p", { key: i }, _toDisplayString(solutionLine), 1))
                    }), 128)),
                    _createElementVNode("p", null, _toDisplayString(_ctx.confirmSolutionText), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.solveFailureInfo.text, (text, i) => {
                      return (_openBlock(), _createElementBlock("p", { key: i }, _toDisplayString(text), 1))
                    }), 128)),
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.solveFailureInfo.actions, (action, i) => {
                        return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(action), 1))
                      }), 128))
                    ])
                  ], 64))
            ])
          ])),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.showYesButton)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              disabled: !_ctx.yesBtnEnabled,
              class: "btn px-5 btn-secondary",
              "aria-label": "Yes",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onYesClicked && _ctx.onYesClicked(...args)))
            }, [
              _cache[4] || (_cache[4] = _createTextVNode(" Yes ")),
              (_ctx.implementingSolution)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5))
                : _createCommentVNode("", true)
            ], 8, _hoisted_4))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          type: "button",
          class: "btn px-5 btn-secondary",
          "aria-label": "No",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onNoClicked && _ctx.onNoClicked(...args)))
        }, _toDisplayString(_ctx.noButtonText), 1)
      ])
    ]),
    _: 1
  }, 8, ["close-button-aria-label"]))
}